import type { PhotoCandid } from '@/api/types/photo'
import type { PhotosTraySort } from './types/photos-tray-sort'

export const PHOTOS_TRAY_SORT_DEFAULT: PhotosTraySort = 'newest'

export const PHOTOS_TRAY_SORT_OPTIONS: ReadonlyArray<{
  value: PhotosTraySort
  label: string
}> = [
  { value: 'newest', label: 'Newest first' },
  { value: 'oldest', label: 'Oldest first' },
  { value: 'az', label: 'A to Z' },
  { value: 'za', label: 'Z to A' },
]

export function isPhotosTraySort(value: unknown): value is PhotosTraySort {
  return value === 'newest' || value === 'oldest' || value === 'az' || value === 'za'
}

function compareDisplayName(left: string, right: string): number {
  return left.localeCompare(right, undefined, { sensitivity: 'base', numeric: true })
}

function uploadDateOr(photo: PhotoCandid, fallback: number): number {
  const value = photo.uploadDate

  if (value == null || !Number.isFinite(value)) return fallback

  return value
}

/** Reorder tray photos. Missing `uploadDate` sorts last for Newest/Oldest. */
export function sortTrayPhotos(photos: PhotoCandid[], sort: PhotosTraySort): PhotoCandid[] {
  return photos
    .map((photo, index) => ({ photo, index }))
    .sort((left, right) => {
      let cmp = 0

      if (sort === 'az' || sort === 'za') {
        cmp = compareDisplayName(left.photo.displayName, right.photo.displayName)
        if (sort === 'za') cmp = -cmp
      } else if (sort === 'newest') {
        cmp =
          uploadDateOr(right.photo, Number.NEGATIVE_INFINITY) -
          uploadDateOr(left.photo, Number.NEGATIVE_INFINITY)
      } else {
        cmp =
          uploadDateOr(left.photo, Number.POSITIVE_INFINITY) -
          uploadDateOr(right.photo, Number.POSITIVE_INFINITY)
      }

      if (cmp !== 0) return cmp

      return left.index - right.index
    })
    .map(({ photo }) => photo)
}
